import { render, staticRenderFns } from "./RateRegisterListPage.vue?vue&type=template&id=22d9e0c4&scoped=true&"
import script from "./RateRegisterListPage.vue?vue&type=script&lang=ts&"
export * from "./RateRegisterListPage.vue?vue&type=script&lang=ts&"
import style0 from "./RateRegisterListPage.vue?vue&type=style&index=0&id=22d9e0c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d9e0c4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTextField,VTooltip})
